angular
  .module('bb.appointments')
  .factory('AppointmentConfigService', AppointmentConfigService);

AppointmentConfigService.$inject = ['$http', '$resource'];
function AppointmentConfigService($http, $resource) {
  const ListingAppointmentConfig = $resource(
    '/listing/:listingId/appointments/config',
    { listingId: '@listingId' },
  );

  const AppointmentContactConfig = $resource(
    '/appointments/:listingId/config/contacts/:contactId',
    {
      listingId: '@listingId',
      contactId: '@contactId',
    },
    {
      update: {
        method: 'POST',
        url: '/appointments/:listingId/config/updateContacts',
      },
      delete: {
        method: 'POST',
        url: '/appointments/:listingId/config/contacts/deleteContact/:contactId',
      },
    },
  );

  const SupraLockboxAccessHours = $resource(
    `/supra/:serialNumber/access_hours`,
    { serialNumber: `@serialNumber` },
  );

  const ListingContacts = $resource('/appointments/:listingId/config/contacts');

  function getListingAppointmentConfig(listingId) {
    return ListingAppointmentConfig.get({ listingId }).$promise;
  }

  function getSupraLockboxAccessHours(serialNumber) {
    return SupraLockboxAccessHours.get({ serialNumber }).$promise;
  }

  function updateConfigContacts(contact) {
    return AppointmentContactConfig.update(contact).$promise;
  }

  function saveConfigContact(contact) {
    return AppointmentContactConfig.save(contact).$promise;
  }

  function deleteConfigContact(listingId, contactId) {
    return AppointmentContactConfig.delete({ listingId, contactId }).$promise;
  }

  function getListingContacts(listingId) {
    return ListingContacts.get({ listingId }).$promise;
  }

  function createClientContact({
    listingId,
    contactBody,
    contactConfig,
    ownerId,
  }) {
    return $http.post(`/appointments/${listingId}/config/contacts/client`, {
      contactBody,
      contactConfig,
      ownerId,
    });
  }

  function updateClientContact({
    listingId,
    contactId,
    contactBody,
    contactConfig,
    updateConfigOnly,
  }) {
    return $http.post(
      `/appointments/${listingId}/config/contacts/client/${contactId}`,
      {
        contactBody,
        contactConfig,
        updateConfigOnly,
      },
    );
  }

  return {
    getListingAppointmentConfig,
    getSupraLockboxAccessHours,
    updateConfigContacts,
    saveConfigContact,
    deleteConfigContact,
    getListingContacts,
    createClientContact,
    updateClientContact,
  };
}

export {};
